import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ShapeSettingsModalView from '../component/ShapeSettingsModalView'
import { shapeColorSettings } from '../../DrawMap/settings'
import WeekSelect from '../../Form/SelectDashboard/types/WeekSelect/WeekSelect'
import { Input } from '../../Form/Input'
import styles from '../styles'

const ShapeSettingsModal = ({
  visible,
  onDelete,
  onUpdate,
  onClose,
  positionInsideParent,
  selectedOverlay,
  shouldPickWeek,
  countryCode,
  infoRows,
  saving,
  viewMode,
  children,
}) => {
  if (!visible || !selectedOverlay) return null
  const [colorCode, setColorCode] = useState(
    selectedOverlay.strokeColor || shapeColorSettings.fillColor,
  )
  const [date, setDate] = useState(
    selectedOverlay.payload && selectedOverlay.payload.date,
  )
  const [label, setLabel] = useState(
    selectedOverlay.payload && selectedOverlay.payload.label,
  )

  const handleSetColorValue = colorValue => {
    if (selectedOverlay) {
      selectedOverlay.set('strokeColor', colorValue)
      selectedOverlay.set('fillColor', colorValue)
      setColorCode(colorValue)
      onUpdate(selectedOverlay)
    }
  }

  const handleWeekChange = date => {
    setDate(date)
    selectedOverlay.set('payload', { ...selectedOverlay.payload, date })
    onUpdate(selectedOverlay, { date })
  }

  const changeOverlayLabel = label => {
    selectedOverlay.set('payload', { ...selectedOverlay.payload, label })
    setLabel(label)
  }

  return (
    <ShapeSettingsModalView
      onDelete={onDelete}
      onClose={onClose}
      setColorValue={handleSetColorValue}
      positionInsideParent={positionInsideParent}
      colorValue={colorCode}
      infoRows={infoRows}
      showDeleteButton={selectedOverlay.canBeDeleted}
      editingBlocked={selectedOverlay.editingBlocked}
      saving={saving}
    >
      {!selectedOverlay.editingBlocked && shouldPickWeek && (
        <WeekSelect value={date} onChange={handleWeekChange} />
      )}
      <Input
        label="Label"
        disabled={selectedOverlay.editingBlocked}
        value={label}
        onChange={e => changeOverlayLabel(e.target.value)}
      />
      {!viewMode && (
        <button onClick={() => onUpdate(selectedOverlay, { label })}>
          Save label
        </button>
      )}
      {selectedOverlay.link && (
        <Link style={styles.simpleText} to={selectedOverlay.link}>
          Mission {selectedOverlay.customId}
        </Link>
      )}
    </ShapeSettingsModalView>
  )
}

export default ShapeSettingsModal



// WEBPACK FOOTER //
// ./src/Components/ShapeSettingsModal/container/ShapeSettingsModal.js